import React, { FC } from "react";
import { SkeletonBase } from "@foris/avocado-suite";
import scss from "./catalogs.module.scss";

interface CatalogsSkeletonProps {
  items: any[];
}

const CatalogsSkeleton: FC<CatalogsSkeletonProps> = ({ items }) => {
  return (
    <div className={scss.catalogsSkeleton}>
      <SkeletonBase maxWidth={"100%"} height={24} />
      <SkeletonBase className={scss.catalogsSkeleton_search} maxWidth={269} height={36} />
      <div className={scss.catalogsSkeleton_filter}>
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
      </div>
      <div className={scss.catalogsSkeleton_cards}>
        {items.map((_, _index) => {
          return (
            <div className={scss.card} key={_index}>
              <SkeletonBase maxWidth={"100%"} height={22} />
              <SkeletonBase maxWidth={"100%"} height={61} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CatalogsSkeleton;
